import { Point } from 'paper'

export const shapesLayout3 = [
  {
    shape: 'leaf',
    position: new Point(5, 15),
    scale: 1,
    rotate: -40,
    color: 'red',
    overlay: {
      shape: 'overlay',
      scale: 1,
      translate: new Point(75, -50),
      rotate: 0
    }
  },
  {
    inset: 'soy-1',
    position: new Point(5, 25),
    scale: 0.8,
    rotate: 0
  },
  {
    shape: 'tilde',
    position: new Point(5, 42),
    scale: 1.25,
    rotate: -40,
    color: 'green',
    overlay: {
      shape: 'overlay',
      scale: 0.75,
      translate: new Point(50, -220),
      rotate: 0
    }
  },
  {
    inset: 'cardamom',
    position: new Point(6, 57),
    scale: 0.8,
    rotate: 0
  },
  {
    shape: 'golf_club',
    position: new Point(90, 7),
    scale: 1.65,
    rotate: 285,
    color: 'purple',
    overlay: {
      shape: 'overlay',
      scale: 1.25,
      translate: new Point(-350, 50),
      rotate: 0
    }
  },
  {
    shape: 'blobby',
    position: new Point(95, 18),
    scale: 1.5,
    rotate: 0,
    color: 'blue',
    overlay: 0
  },
  {
    inset: 'garlic',
    position: new Point(95, 36),
    scale: 0.8,
    rotate: 0
  },
  {
    shape: 'blob',
    position: new Point(90, 60),
    scale: 1.25,
    rotate: 0,
    color: 'yellow',
    overlay: {
      shape: 'overlay',
      scale: 1,
      translate: new Point(-350, -200),
      rotate: 0
    }
  },
  {
    shape: 'blobby',
    position: new Point(85, 66),
    scale: 1,
    rotate: 0,
    color: 'skinTone',
    overlay: 0
  },
  {
    inset: 'green-chili',
    position: new Point(96, 85),
    scale: 0.6,
    rotate: 0
  },
  {
    shape: 'smudge',
    position: new Point(8, 73),
    scale: 0.75,
    flipX: true,
    rotate: 325,
    color: 'blue',
    overlay: {
      shape: 'overlay',
      scale: 1,
      translate: new Point(110, -50),
      rotate: 0
    }
  }
]
